var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundButtonNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#251F2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8718 7.88331C14.6135 7.63529 14.2847 7.5 13.8973 7.5C13.1223 7.5 12.5 8.08624 12.5 8.83033C12.5 9.20237 12.6644 9.54059 12.9344 9.79989L21.1536 17.5113L12.9344 25.2001C12.6644 25.4594 12.5 25.8089 12.5 26.1697C12.5 26.9138 13.1223 27.5 13.8973 27.5C14.2847 27.5 14.6135 27.3647 14.8718 27.1167L24.0068 18.5485C24.3356 18.2554 24.4883 17.8946 24.5 17.5C24.5 17.1054 24.3356 16.7672 24.0068 16.4628L14.8718 7.88331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundButtonNext);
export default __webpack_public_path__ + "static/media/round_button_next.4c40614c5298c6da9645368c4cb282d6.svg";
export { ForwardRef as ReactComponent };